module.exports = __webpack_public_path__ + "static/img/logo_header.b1bc379.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_header.png
// module id = cEgI
// module chunks = 1